export default "__VITE_ASSET__930a0e7a__$_?react__"